import { Component } from '@angular/core';
import { SidebarServiceService } from '../../services/sidebar-service.service';
import { NavbarComponent } from '../navbar/navbar.component';
import { AngularMaterialModule } from '../../angular-material.module';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FooterComponent } from '../footer/footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-template',
  standalone: true,
  imports: [NavbarComponent,AngularMaterialModule,SidebarComponent ,FooterComponent,CommonModule,SidebarComponent],
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'] // Corrected to styleUrls
})
export class TemplateComponent {
  constructor(public sidebarStateService: SidebarServiceService) { }
}
